import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import {
    BridgeConnectorMetadata,
    CreateConnectorMetadataRequest,
    UpdateConnectorMetadataRequest,
    ConnectorObject
} from "../../../models/bridge/bridge-connector-metadata.model";
import { BridgeBaseService } from "./bridge-base.service";

/**
 * Service for 4Bridge Connector Metadata API
 */
@Injectable({
    providedIn: 'root'
})
export class BridgeConnectorMetadataService extends BridgeBaseService<BridgeConnectorMetadata> {

    constructor(httpClient: HttpClient) {
        super(httpClient, 'connector-metadata');
    }

    /**
     * Get metadata by connector type
     */
    public getByConnectorType(connectorType: string): Observable<BridgeConnectorMetadata> {
        return this.httpClient
            .get<BridgeConnectorMetadata>(`${this.baseUrl}/${this.endpoint}/type/${connectorType}`)
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Get all enabled connectors
     */
    public getEnabledConnectors(): Observable<BridgeConnectorMetadata[]> {
        return this.httpClient
            .get<BridgeConnectorMetadata[]>(`${this.baseUrl}/${this.endpoint}?enabled=true`)
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Create connector metadata (admin only)
     */
    public createMetadata(request: CreateConnectorMetadataRequest): Observable<BridgeConnectorMetadata> {
        return this.create(request as any);
    }

    /**
     * Update connector metadata (admin only)
     */
    public updateMetadata(id: string, request: UpdateConnectorMetadataRequest): Observable<BridgeConnectorMetadata> {
        return this.update(id, request as any);
    }

    /**
     * Get available objects for a connector type
     */
    public getConnectorObjects(connectorType: string): Observable<ConnectorObject[]> {
        return this.httpClient
            .get<ConnectorObject[]>(`${this.baseUrl}/${this.endpoint}/type/${connectorType}/objects`)
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }

    /**
     * Refresh metadata from external source
     */
    public refreshMetadata(id: string): Observable<BridgeConnectorMetadata> {
        return this.httpClient
            .post<BridgeConnectorMetadata>(`${this.baseUrl}/${this.endpoint}/${id}/refresh`, {})
            .pipe(
                catchError((error) => this.handleError(error))
            );
    }
}
